import { raw, escape } from '../core/html.js';
import { artworkManifest } from '../data/artwork.js';

/**
 * Responsive artwork.
 *
 * Widths come from the generated manifest, so the srcset only ever lists renditions
 * that exist. The untouched source stays as the <img> fallback.
 */
export const artwork = (name, alt, { sizes = '(max-width: 720px) 100vw, 400px', priority = false } = {}) => {
  const entry = artworkManifest[name];
  if (!entry) throw new Error(`Unknown artwork: ${name}`);

  const srcset = entry.widths.map((w) => `/assets/images/generated/${name}-${w}.webp ${w}w`).join(', ');
  const loading = priority
    ? 'loading="eager" fetchpriority="high"'
    : 'loading="lazy" fetchpriority="auto"';

  return raw(
    '<picture class="artwork">' +
      `<source type="image/webp" srcset="${srcset}" sizes="${escape(sizes)}">` +
      `<img src="/assets/images/${entry.source}" alt="${escape(alt)}" ` +
      `width="${entry.width}" height="${entry.height}" ${loading} decoding="async">` +
    '</picture>',
  );
};
